'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FileModel;
function FileModel($parse) {
  'ngInject';

  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      var model = $parse(attrs.fileModel);
      var modelSetter = model.assign;

      element.bind('change', function () {
        scope.$apply(function () {
          modelSetter(scope, element[0].files[0]);
        });
      });
    }
  };
};


// WEBPACK FOOTER //
// ./src/credit-request/shared/components/file-model.js